import React from "react";

import styles from './DotsLoadingAnimation.module.css'

function DotsLoadingAnimation(props) {
    return (
        <div {...props} className={styles.loader}><div></div><div></div><div></div><div></div></div>
    );
}

export default DotsLoadingAnimation;